import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Item } from '../../../../modules/shared/dropdown/dropdown.models';
import { MarginService } from '../../services/margincalc.service';
import { AccName, BillHours, FetchMarginData, FilterData, MarketName, MarginData,  ReqBy, EditFilterData } from '../../models/margin-modal';
import { v4 } from 'uuid';
import { DropdownComponent } from 'src/app/modules/shared/dropdown/dropdown.component';
import { GlobalStoreService } from 'src/app/modules/global/services/global-store.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalMarginComponent } from '../confirmation-modal-margin/confirmation-modal-margin.component';
import { eventNames } from 'process';
import { Subscription } from 'rxjs';
import { MarginCalcStoreService } from '../../services/margincalc-store.service';
@Component({
  selector: 'MarginApp-filter',
  standalone: false,
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.scss'],
})

export class MarginAppFilterComponent implements OnInit, OnDestroy {
  othersSelected: boolean = false;
  otherSelected: boolean = false;
  marketName: Item[] =[];
  accountName: Item[] = [];
  filteredAccountName:Item[]=[]
  requestedBy:Item[]=[];
  offBillableHours:Item[]=[];
  onBillableHours:Item[]=[];
  accountNameSelected:string;
  requestedBySelected:string;
  marketSelected: string;
  requestedByCTID: string;
  offBillable:number=8;
  onBillable:number=8;
  location:string[];
  passcode: string;
  fetchMarginData: FetchMarginData[]=[];
  primaryData: FetchMarginData[];
  userLogedIn:string;
  filterData:FilterData;
  requestedByOthers: string;
  accountNameOthers: string;
  c:number=0;
  marginFilterSub: Subscription;
  editFilterSub: Subscription;
  getMarginSub: Subscription;

  constructor(private service: MarginService,private modalService: NgbModal, private global:GlobalStoreService, private storeService: MarginCalcStoreService) {
    this.getMarginSub = this.service.getMarginData().subscribe((res) => {
      this.filterValuePopulation(res);
    });
  }
@ViewChild('marketDropdown') marketNameDropdown: DropdownComponent;
@ViewChild('accountNameDropdown') accountNameDropdown: DropdownComponent;
@ViewChild('requestedByDropdown') requestedByDropdown: DropdownComponent;
@ViewChild('offBillableDropdown') offBillableHoursDropdown: DropdownComponent;
@ViewChild('onBillableDropdown') onBillableHoursDropdown: DropdownComponent;
@ViewChild('passcodeInput') passcodeInput!: ElementRef<HTMLInputElement>;

  ngOnInit(): void {
    this.marginFilterSub = this.service.fetchmarginButtonEventEmitter.subscribe(()=>{
      const passcode = this.passcodeInput?.nativeElement?.value?.trim() || '';
      this.onMarginClick(passcode);
    });
    this.editFilterSub = this.service.editMarginEmitter.subscribe((data:EditFilterData) => {
      this.marketSelected = data.marketName;
      this.accountNameSelected = data.accountName;
      this.offBillable = data.Offshore_Billable_Hrs;
      this.onBillable = data.Onsite_Billable_Hrs;
      this.storeService.filterData.SelectedMarket = this.marketSelected;
      this.storeService.filterData.SelectedAccountname = this.accountNameSelected;
      this.storeService.filterData.Offshore_Billable_Hrs = this.offBillable;
      this.storeService.filterData.Onsite_Billable_Hrs = this.onBillable;
      this.marketName.forEach((item,index) => {
        if(item.name === data.marketName) {
          item.checked = true;
        }
        else {
          item.checked = false;
        }
      });
      this.accountName.forEach((item,index) => {
        if(item.name === data.accountName) {
          item.checked = true;
        }
        else {
          item.checked = false;
        }
      });
      let accName:any = [];
      accName = this.accountName.filter(x => x.checked === true);
      if(accName.length === 0 && data.accountName.length !== 0) {
        this.accountName.find(x => x.name === 'Others').checked = true;
        this.othersSelected = true;
      }
      else {
        this.othersSelected = false;
      }
      this.offBillableHours.forEach((item,index) => {
        if(item.name === (''+data.Offshore_Billable_Hrs)) {
          item.checked = true;
        }
        else {
          item.checked = false;
        }
      });
      this.onBillableHours.forEach((item,index) => {
        if(item.name === (''+data.Onsite_Billable_Hrs)) {
          item.checked = true;
        }
        else {
          item.checked = false;
        }
      });
    });
  }

  filterValuePopulation(data: MarginData) {
    this.marketNameFill(data.MarketName);
    this.accountNameFill(data.AccountName);
    // this.requestedByFill(data.RequestedBy);
    this.offBillableHoursFill(data.BillingHours);
    this.service.dataEmitter.emit(data);
  }
  fetchMarginEmitter(data:FilterData){
    this.service.fetchMarginEmitter.emit(data);
  }

  marketNameFill(data: MarketName[]) {
  data.forEach((element,index) => {
   this.marketName.push({
     uuid: v4(),
     id:1+index ,
     marketId:element.MarketId,
     name:' ' + element.MarketName,
     checked: false,
     visible: true
   });
  });

  this.marketNameDropdown.list=this.marketName;
  this.marketNameDropdown.search='';
  }
  accountNameFill(data: AccName[]) {
    data.forEach((element, index) => {
      this.accountName.push({
        uuid: v4(),
        id: 1 + index,
        marketId:element.MarketId,
        name: element.ClientName,
        checked: false,
        visible: true,
      });
    });

    this.accountName=[
      ...this.accountName,

      {
          uuid: v4(),
          id: -1,
          marketId:-1,
          name: "Others",
          checked: false,
          visible: true
      } as Item
    ]

    this.filteredAccountName=this.accountName;
    this.accountNameDropdown.list=this.filteredAccountName;
    this.accountNameDropdown.search='';
  }

//   requestedByFill(data: ReqBy[]) {
//   data.forEach((element,index) => {
//    this.requestedBy.push({
//      uuid: v4(),
//      id:1+index ,
//      name:element.EmployName,
//      checked: false,
//      visible: true,
//    });
//  });
//  this.requestedBy=[
//   ...this.requestedBy,

//   {
//       uuid: v4(),
//       id: -1,
//       marketId:-1,
//       name: "Others",
//       checked: false,
//       visible: true
//   } as Item
// ]
//  this.requestedByDropdown.list=this.requestedBy;
//  this.requestedByDropdown.search='';
// }

offBillableHoursFill(data: BillHours[]) {
data.forEach((element,index) => {
 this.offBillableHours.push({
   uuid: v4(),
   id:1+index ,
   name:""+ element.biling_hrs,
   checked: element.biling_hrs==8,
   visible: true,
 });
 this.onBillableHours.push({
  uuid: v4(),
  id:1+index ,
  name:""+ element.biling_hrs,
  checked: element.biling_hrs==8,
  visible: true,
});
});

this.offBillableHoursDropdown.list=this.offBillableHours;
this.onBillableHoursDropdown.list=this.onBillableHours;
this.offBillableHoursDropdown.search='';
this.onBillableHoursDropdown.search='';
}
  onDropdownItemChange({ $event, item }) {
    // console.log(item);
    if (item.id === -1 && item.name==='Others'){
      this.othersSelected = true;
      this.accountNameSelected = '';
    }
    else {
    this.othersSelected = false;
    this.accountNameSelected=item.name;
    }

    this.storeService.filterData.SelectedAccountname = this.accountNameSelected;
  }

  otherAccountNameValue(value: string){
    this.accountNameSelected = value;
    this.storeService.filterData.SelectedAccountname = this.accountNameSelected;
    // console.log(this.accountNameSelected);

  }
  // onItemChange({ $event, item }) {
  //   // console.log(item);
  //   if (item.id === -1 && item.name==='Others'){
  //     this.otherSelected = true;
  //     this.requestedBySelected = '';
  //   }
  //   else{
  //   this.otherSelected = false;
  //   this.requestedBySelected= item.name;
  //   }
  // }
  // otherRequestedByValue(value: string){
  //   this.requestedBySelected = value;
  //   // console.log(this.requestedBySelected);
  // }
  onOffBliiableChange(hours:any){
    this.offBillable=hours;
    this.storeService.filterData.Offshore_Billable_Hrs = this.offBillable;
  }
  onOnBliiableChange(hours:number){
    this.onBillable=hours;
    this.storeService.filterData.Onsite_Billable_Hrs = this.onBillable;
  }
  onMarketChange({$event, item}){
    this.othersSelected = false;
    this.marketSelected= item.name;
    let i=item.marketId;

    this.storeService.filterData.SelectedMarket = this.marketSelected;
    this.filteredAccountName=this.accountName.filter(x=>x.marketId===i||x.marketId===-1);
    this.accountNameSelected='';
    this.accountNameDropdown.list=this.filteredAccountName;
    this.accountNameDropdown.search='';
    this.accountNameDropdown.search='';
  }
  //Fetch Margin Functionality
   onMarginClick(passcode: string) {
    passcode = this.passcodeInput?.nativeElement?.value?.trim() || '';
    this.passcode=passcode;
    this.filterData={
      Passcode:this.passcode,
      SelectedMarket: this.marketSelected,
      SelectedAccountname:this.accountNameSelected == 'Others' ? this.accountNameOthers : this.accountNameSelected,
      SelectedRequestedBy:this.global.profile.EmployeeName,
      Offshore_Billable_Hrs: this.offBillable,
      Onsite_Billable_Hrs: this.onBillable
    };
    // console.log(this.filterData);
    if(this.marketSelected === undefined || this.marketSelected === ""){
      this.warningDialogacc('Market');
    }
    else if(this.accountNameSelected === undefined || this.accountNameSelected === ""||this.accountNameSelected === " "){
      this.warningDialogacc1('Account Name');
    }
    // else if(this.requestedBySelected === undefined || this.requestedBySelected === "" ){
    //   this.warningDialogacc2('Requested By');
    // }
    else
    this.fetchMarginEmitter(this.filterData);
  }

  omitSpecialChar(event){
    var k;
    k= event.charCode;
    if(k==32){
      this.c++;
    }else
    this.c=0;
    if(this.c==1)
    return k==32;
    return((k>64 && k<91)||(k>96&&k<123)||k==8||(k>=48&&k<=57));
  }
    warningDialogacc(value:string) {
      const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
        centered: true,
        backdrop: 'static'
      });
      modalRef.componentInstance.message = 'Please select ' + ' ' +value;
    }

    warningDialogacc1(value:string) {
      const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
        centered: true,
        backdrop: 'static'
      });
      if(this.othersSelected==true)
      modalRef.componentInstance.message = 'Please enter ' + ' ' +value;
      else
      modalRef.componentInstance.message = 'Please select ' + ' ' +value;
    }
    warningDialogacc2(value:string) {
      const modalRef = this.modalService.open(ConfirmationModalMarginComponent, {
        centered: true,
        backdrop: 'static'
      });
      if(this.otherSelected==true)
      modalRef.componentInstance.message = 'Please enter ' + ' ' +value;
      else
      modalRef.componentInstance.message = 'Please select ' + ' ' +value;
    }

    ngOnDestroy(): void {
      if(this.getMarginSub) {
        this.getMarginSub.unsubscribe();
      }
      if(this.marginFilterSub){
        this.marginFilterSub.unsubscribe();
      }
      if(this.editFilterSub) {
        this.editFilterSub.unsubscribe();
      }
    }
  }





